import React from 'react'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import Button from 'components/_UI/Button'
import buttonText from 'texts/buttons/buttonText'
import styled from 'styled-components'

export default function ConfirmAbsorbedModal({
    isOpen,
    title = 'Alterar taxa de serviço',
    message = 'Isso altera a taxa de serviço de todos os ingressos deste evento.',
    onConfirm = () => {},
    onCancel = () => {}
}) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            closeButton
            size='default'
        >
            <Text name='highlight' marginBottom='8px'>
                {title}
            </Text>
            <Text name='default' marginBottom='20px'>
                {message}
            </Text>
            <ButtonRow>
                <Button variant='secondary' onClick={onCancel}>
                    {buttonText.cancel}
                </Button>
                <Button variant='featured' onClick={onConfirm}>
                    {buttonText.confirm}
                </Button>
            </ButtonRow>
        </Modal>
    )
}

const ButtonRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 8px;
`
